export const DEMO_EMAIL = 'example@paperculture.com'

export const isDemoEmail = (email: string): boolean => email === DEMO_EMAIL
